<template>
	<!--
		 Actifs
	-->
	<div class="row" v-if="subsection.type == 'actifs' || subsection.type == 'females' || subsection.type == 'futsal'">
		<div class="col">
			<div class="row" v-if="!$root.documentsOpen">
				<div class="col-lg-6 col-xl-4" v-for="team in subsection.teams">
					<router-link :to="{name: 'page', params: {sectionSlug: section.slug, subsectionSlug: subsection.slug, pageSlug: team.slug}}" class="teams__block gsap-fade-up">
						<div class="teams__image" v-if="team.image" :style="{'background-image': 'url('+ medium(team.image) +')'}"></div>
						<div class="teams__content">
							<p class="teams__season"></p>
							<h1 class="teams__name">{{team.name}}</h1>
							<span class="teams__visit">Voir l’équipe</span>
						</div>
					</router-link>
				</div>
			</div>
			<teams-documents v-if="subsection.content" differentCategory="true" :subsection="subsection"></teams-documents>
		</div>
	</div>

	<!--
		 Juniors
	-->
	<div class="row" v-else-if="subsection.type == 'juniors'">

		<div class="col juniors juniors-sub-category" v-if="$root.juniorsSubCategory && $root.juniorsSubCategory.type == 'football_de_base'">
			<div class="row" v-if="!$root.documentsOpen">
				<div class="col-lg-6 col-xl-4 gsap-fade-up" v-for="category in $root.juniorsSubCategory.children">
					<div
						class="juniors__team">
						<p class="juniors__team-title">{{category.name}}</p>
						<p class="sub-title">Sélectionnez une équipe</p>

						<router-link
							v-for="(team, index) in category.teams"
							class="team-page"
							:key="index"
							:to="{name: 'page', params: {sectionSlug: section.slug, subsectionSlug: subsection.slug, pageSlug: team.slug}}">
							{{team.name}}
						</router-link>
					</div>
				</div>
			</div>
			<teams-documents v-if="$root.juniorsSubCategory.content" :subsection="subsection"></teams-documents>
		</div>

		<!-- Raiffeisen Lancy FC Académie - Teams -->
		<div
			class="col juniors"
			:class="$root.juniorsSubCategory.type"
			v-else-if="$root.juniorsSubCategory && $root.juniorsSubCategory.type == 'raiffeisen_lancy'">
			<div class="row" v-if="!$root.documentsOpen">
				<div class="col-lg-6 col-xl-4" v-for="(team, index) in $root.juniorsSubCategory.teams">
					<router-link
						class="juniors__team gsap-fade-up"
						:key="index"
						:to="{name: 'page', params: {sectionSlug: section.slug, subsectionSlug: subsection.slug, pageSlug: team.slug}}">
							<p class="juniors__team-title">{{team.name}}</p>
							<p class="juniors__team-view">Voir l’équipe</p>
					</router-link>
				</div>
			</div>
			<teams-documents v-if="$root.juniorsSubCategory.content" :subsection="subsection"></teams-documents>
		</div>

		<!-- École de Football -->
		<div
			class="col"
			:class="$root.juniorsSubCategory.type"
			v-else-if="$root.juniorsSubCategory && $root.juniorsSubCategory.type == 'ecole_de_football'">
			<div class="row" v-if="!$root.documentsOpen">
				<div class="col-lg-6 col-xl-4" v-for="(team, index) in $root.juniorsSubCategory.teams">
					<router-link :to="{name: 'page', params: {sectionSlug: section.slug, subsectionSlug: subsection.slug, pageSlug: team.slug}}" class="teams__block gsap-fade-up">
						<div class="teams__image" v-if="team.image" :style="{'background-image': 'url('+ medium(team.image) +')'}"></div>
						<div class="teams__content">
							<h1 class="teams__name">{{team.name}}</h1>
							<span class="teams__visit">Voir l’équipe</span>
						</div>
					</router-link>
				</div>
			</div>
			
			<teams-documents v-if="$root.juniorsSubCategory.content" :subsection="subsection"></teams-documents>
		</div>


		<!-- If not subcategory is selected -->
		<div class="col juniors" v-else-if="!$root.juniorsSubCategory">
			<div class="row">
				<div class="col-lg-6 col-xl-4 gsap-fade-up" v-for="junoirSubCategory in subsection.children">
					<a
						@click.prevent="showLastCategory(junoirSubCategory)" :to="{name: 'page', params: {sectionSlug: section.slug, subsectionSlug: subsection.slug, pageSlug: junoirSubCategory.slug}}" class="juniors__team">
						<p class="juniors__team-title">{{junoirSubCategory.name}}</p>
						<p class="juniors__team-view">Voir les équipes</p>
					</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import _find from 'lodash/find'
	import teamsDocuments from './teams-documents'

	export default {
		name: 'TeamsComponent',
		props: ['section'],
		components: {
			teamsDocuments: teamsDocuments
		},
		data() {
			return {
				juniors: {
					subCategory: false
				}
			}
		},
		methods: {
			showLastCategory(val) {
				this.$root.juniorsSubCategory = val
				this.$nextTick(() => {
					TweenMax.staggerFromTo('.ecole_de_football .gsap-fade-up', .5, {opacity: 0, y:15}, {opacity: 1, y:0}, 0.2)
					TweenMax.staggerFromTo('.juniors .juniors__team', .5, {opacity: 0, y:15}, {opacity: 1, y:0}, 0.2)
				})
			}
		},
		computed: {
			...mapState([
				'teams',
				'teamsWithCategories'
			]),
			subsection() {
				return _find(this.teamsWithCategories, {slug: this.$route.params.subsectionSlug})
			}
		}
	}
</script>